// eslint-disable-next-line func-names
(function (Drupal, $) {
  const initToggleSidebarMenu = (el, overlayEl) => {
    const $toggler = $(el);
    const targetID = $toggler.data('target');
    const $sidebar = $(`#${targetID}`);
    const $overlay = $(overlayEl);
    const $siteContainer = $('.site-container__top'); // container with limited width
    const $containersToPush = $('.site-container__top, .site-footer, .site-header, .newsletter'); // containers to push when sidebar is opening
    const sidebarWidth = $sidebar.outerWidth();

    if (!$sidebar.length) {
      return;
    }

    const handleUsingEscKey = (e) => {
      const key = e.key || e.keyCode;
      if (key === 27 || key === 'Escape') {
        const { closeSidebar } = e.data;

        if (closeSidebar) {
          closeSidebar(e);
        }
      }
    };

    const onContainerMoveBack = (e) => {
      const { target } = e;

      $(target).css({
        transform: '',
        transition: '',
        overflowX: '',
        marginRight: '',
      });

      $('body').removeClass(['overflow-hidden', 'menu-opened']);

      setTimeout(() => {
        $('body').removeClass('hide-scrollbar');
      }, 600);

      $(target).off('transitionend', null, onContainerMoveBack);
    };

    const onContainerMove = (e) => {
      const { target } = e;

      setTimeout(() => {
        $('body').removeClass('hide-scrollbar');
      }, 600);

      $(target).off('transitionend', null, onContainerMove);
    };

    const closeSidebar = (e) => {
      const { sidebar, overlay } = e.data;
      sidebar.attr('data-expanded', false);
      sidebar.removeClass('is-open');

      $containersToPush.css({
        transform: 'translateX(0)',
      });

      overlay.off('click', closeSidebar);

      overlay.removeClass(['is-open']);

      $containersToPush.on('transitionend', onContainerMoveBack);

      $(document).off('keydown', handleUsingEscKey);

      overlay.remove();
    };

    const openSidebar = (sidebar, overlay) => {
      /** We need to push container tight to the sidebar if its wide is limited on desktop
       *  screens and less.  */
      const margin = $siteContainer.offset().left;

      sidebar.addClass('is-open');

      $('body').addClass(['overflow-hidden', 'menu-opened', 'hide-scrollbar']);

      $containersToPush.css({
        transform: `translateX(-${sidebarWidth - margin}px)`,
        transition: 'transform 250ms ease-in 0ms',
        overflowX: 'visible',
      });

      sidebar.attr({ 'data-expanded': true });

      overlay.addClass('is-open');
      overlay.on('click', { sidebar, overlay }, closeSidebar);

      $containersToPush.on('transitionend', onContainerMove);

      $(document).on('keydown', { sidebar, overlay, closeSidebar }, handleUsingEscKey);
    };

    $toggler.on('click keypress', { sidebar: $sidebar, overlay: $overlay }, (e) => {
      if ($toggler.data('action').includes('hide')) {
        closeSidebar(e);

        const key = e.key || e.keyCode;
        if (key === 13 || key === 'Enter') {
          $('button[data-action="show-main-menu"]').trigger('focus');
        }
        return;
      }

      if ($toggler.data('action').includes('show')) {
        $('.site-container').append($overlay);
        openSidebar($sidebar, $overlay);

        const key = e.key || e.keyCode;
        if (key === 13 || key === 'Enter') {
          $sidebar.find('button[data-action="hide-main-menu"]').trigger('focus');
        }
      }
    });

    const sidebarHtml = $sidebar.get(0);

    if (sidebarHtml) {
      const config = { attributes: true };

      const callback = (mutationList) => {
        mutationList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-expanded') {
            if (sidebarHtml.dataset.expanded === 'true') {
              if ($toggler.data('action').includes('hide')) {
                $toggler.removeAttr('tabindex');
              }

              setTimeout(() => {
                sidebarHtml.style.transition = null;
                sidebarHtml.focus();
              }, 300);
            } else if ($toggler.data('action').includes('hide')) {
              $toggler.attr('tabindex', '-1');
            }
          }
        });
      };

      const observer = new MutationObserver(callback);

      observer.observe(sidebarHtml, config);
    }
  };
  Drupal.behaviors.mstToggleSidebarMenu = {
    attach(context) {
      const overlay = $('<div />', {
        class: ['overlay', 'overlay--menu'].join(' '),
      });

      const $buttons = $(
        'button[data-action="hide-main-menu"], button[data-action="show-main-menu"]',
        context,
      );
      $buttons.each((index, el) => initToggleSidebarMenu(el, overlay));
    },
  };
}(Drupal, jQuery));
